<template>
  <div class="mt-4">
    <list-form
      ref="list-form"
      :config="config"
      :formModel="formModel"
      :prepareGet="prepareGet"
      @onGet="handlerGetData"
      @onUpdateDataItem="updateListRFQ2"
    >
      <template v-slot:title="{ title }">
        <h3 class="blue-text">{{title}}</h3>
        <div class="app-button-wrapper">
          <button type="button" class="btn btn-size-s btn-mobile-full" @click="isShowDialogAddSupplierQuote = true">{{L10n('add-supplier-quote')}}</button>
          <button type="button" class="btn btn-size-s btn-mobile-full" @click="isShowDialogAttachSupplierQuote = true">{{L10n('attach-supplier-quote')}}</button>
        </div>
      </template>
      <template v-slot:first-of-group ="{ item }">
        <h4 class="blue-text">{{item.supplierCompanyName}}</h4>
      </template>
      <template v-slot="{ data, item, updateDataItem, updateModelItem, handleCommand }">
        <edit-form
          :config="{ id: config.id }"
          :data="data"
          :model="formModel"
          @on-include-in-po="(value) => handlerIncludeInPO(value, item)"
          @change="updateDataItem($event)"
          @updateModelItem="updateModelItem"
          @updateViewData="updateListRFQ2"
          @command="handleCommand"
        />
      </template>
      <template v-slot:last-of-group="{ item }">
        <create-po-form
          v-show="!isCreatingPO"
          :customerID="customerID"
          :checkValidSupplier="getListIncludeToPO"
          :supplierCompanyID="item.supplierCompanyID"
          :supplierCompanyName="item.supplierCompanyName"
          :data="mapListDataPO[item.supplierCompanyID] || {}"
          @command="commandControllerPOForm"
        ></create-po-form>
      </template>
    </list-form>
    <dialog-add-supplier-quote
      :isVisible.sync="isShowDialogAddSupplierQuote"
      :rfqid="dataRFQ.rfqid"
      @onCreated="refresh"
    />
    <dialog-attach-supplier-quote
      :isVisible.sync="isShowDialogAttachSupplierQuote"
      :rfqid="dataRFQ.rfqid"
      @onAttached="refresh"
    />
  </div>
</template>

<script>
import { waitValue } from '@/utils/promises.js'
import { ServiceRFQ2s } from '@/services/RFQ2s'
import listFormConfig from './ListFormConfig.json'
import { getDefaultRFQID } from '@/utils/shared'

export default {
  name: 'ListFormSupplierQuotes',
  components: {
    'list-form': () => import(/* webpackChunkName: 'ListForm' */ '@/components/ListForm/Index'),
    'edit-form': () => import(/* webpackChunkName: 'SupplierQuotesRFQ2' */ './FormRFQ2.vue'),
    'create-po-form': () => import(/* webpackChunkName: 'SupplierQuotesRFQ2' */ './FormCreatePO.vue'),
    'dialog-add-supplier-quote': () => import(/* webpackChunkName: 'Dialogs' */ './DialogCreateRFQ2'),
    'dialog-attach-supplier-quote': () => import(/* webpackChunkName: 'Dialogs' */ './DialogAttachRFQ2')
  },
  props: {
    rfqid: { required: true },
    customerID: { required: true },
    moduleName: { type: String, required: true }
  },
  watch: {
    rfqid: {
      immediate: true,
      handler () {
        this.getListForm()
          .then((listForm) => {
            let rfqid = this.rfqid
            if (rfqid) {
              listForm.setFilters(`(rfqid == "${rfqid}" && chosen == false) `)
              listForm.loadData()
            } else {
              listForm.clear()
            }
          })
      }
    }
  },
  data () {
    return {
      config: listFormConfig,
      isShowDialogAddSupplierQuote: false,
      isShowDialogAttachSupplierQuote: false
    }
  },
  computed: {
    dataRFQ () {
      return this.$store.state[this.moduleName].dataRFQ
    },
    isCreatingPO () {
      return this.$store.state[this.moduleName].isCreatingPO
    },
    mapListRFQ2 () {
      return this.$store.getters[`${this.moduleName}/mapListRFQ2`]
    },
    mapListDataPO () {
      return this.$store.getters[`${this.moduleName}/mapListDataPO`]
    },
    getListIncludeToPO () {
      return this.$store.getters[`${this.moduleName}/getListIncludeToPO`]
    }
  },
  methods: {
    getListForm () {
      return waitValue(() => this.$refs['list-form'])
    },
    refresh () {
      this.getListForm()
        .then((listForm) => {
          listForm.refresh()
        })
    },
    prepareGet (data) {
      return data.map((item) => {
        let _includeInPo = !!(this.mapListRFQ2[item.id] && this.mapListRFQ2[item.id]._includeInPo)
        return {
          ...item,
          _includeInPo
        }
      })
    },
    handlerIncludeInPO (value, item) {
      value = {
        ...item,
        _includeInPo: value
      }
      this.$store.commit(`${this.moduleName}/REPLACE_ARRAY_ITEM`, { key: 'listRFQ2', value })
    },
    formModel () {
      let model = {
        ...ServiceRFQ2s.getModel(),
        _includeInPo: false,
        rfqid: getDefaultRFQID(),
        employeeID: this.$store.getters.get('currentUser').employeeID
      }
      return model
    },
    commandControllerPOForm (command, data) {
      if (command === 'create') {
        this.createPO(data)
      }
      if (command === 'mounted') {
        this.$store.commit(`${this.moduleName}/MERGE_ARRAY`, { key: 'listDataPO', value: [data], field: 'supplierCompanyID' })
      }
      if (command === 'update-view') {
        this.$store.commit(`${this.moduleName}/MERGE_ITEM_ARRAY`, { key: 'listDataPO', value: data, field: 'supplierCompanyID' })
      }
    },
    handlerGetData (dataList) {
      this.$store.commit(`${this.moduleName}/MERGE_ARRAY`, { key: 'listRFQ2', value: dataList })
    },
    createPO (data) {
      return this.$store.dispatch(`${this.moduleName}/createPO`, data)
        .then(() => {
          this.getListForm()
            .then((listForm) => {
              listForm.clear()
              listForm.loadData()
            })
        })
        .catch((err) => {
          this.requestErrorHandler(err, err.message)
        })
    },
    updateListRFQ2 (value) {
      this.$store.commit(`${this.moduleName}/MERGE_ITEM_ARRAY`, { key: 'listRFQ2', value })
    }
  }
}
</script>
